export const PRIVACY_WEB_FORM_LINK_TEXT = 'Your Privacy Choices'
export const PRIVACY_WEB_FORM_URL = 'https://privacyportal.onetrust.com/webform/6ab91689-fe4e-4bac-8d52-04fb14560768/72f5e86c-8d21-4c81-a33c-92ce0332ebdf'
